import React from "react";

const Settings = () => {
  return <div class="page-container">
        <h1 class="page-title">Settings</h1>
    </div>
};

export default Settings;
